import { useState } from "react";
import type { Objective } from "../types/game";

interface Props {
  objectives?: Objective[];
}

export function MissionPanel({ objectives }: Props) {
  const [collapsed, setCollapsed] = useState(false);

  const visible = (objectives ?? []).filter(o => o.status !== "hidden");
  if (visible.length === 0) return null;

  const succeededCount = visible.filter(o => o.status === "succeeded").length;
  const failedCount    = visible.filter(o => o.status === "failed").length;
  const total          = visible.length;

  return (
    <div className={`mission-panel${collapsed ? " mission-panel-collapsed" : ""}`}>
      <button
        className="mission-panel-header"
        onClick={() => setCollapsed(c => !c)}
        title={collapsed ? "Expand objectives" : "Collapse objectives"}
      >
        <span className="mission-panel-label">MISSION</span>
        <span className="mission-panel-count">
          {succeededCount}/{total}{failedCount > 0 ? ` · ${failedCount} failed` : ""}
        </span>
        <span className="mission-panel-toggle">{collapsed ? "▾" : "▴"}</span>
      </button>
      {!collapsed && (
        <ul className="mission-objectives">
          {visible.map(o => (
            <li key={o.id} className={`mission-objective mission-objective-${o.status}`}>
              <span className="mission-objective-icon" aria-hidden>
                {o.status === "succeeded" ? "✓" : o.status === "failed" ? "✕" : "·"}
              </span>
              <span className="mission-objective-text">
                {o.text}
                {o.required && <span className="mission-objective-required" title="Required objective"> *</span>}
              </span>
              {o.hint && o.status === "active" && (
                <span className="mission-objective-hint" title={o.hint}>?</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
